import axios from '@/axios-conf'

const state = {
  project: null,
  votingEnds: null,
  votingLink: false
}

const getters = {
  canVote: state => {
    const now = new Date()
    return state.votingEnds && now < new Date(state.votingEnds)
  },
  project: state => {
    return state.project
  },
  votingEnds: state => {
    return state.votingEnds
  },
  votingLink: state => {
    return state.votingLink
  }
}

const mutations = {
  setEndDate: (state, payload) => {
    state.votingEnds = payload
  },
  setProject: (state, payload) => {
    state.project = payload
  },
  setVotingLink: (state, payload) => {
    state.votingLink = payload
  }
}

const actions = {
  async initialize ({dispatch}) {
    return dispatch('loadProject').then(() => {
      dispatch('getVotingLink')
    })
  },
  loadProject ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/api/project/best-of-sac/')
        .then(res => {
          commit('setProject', res.data)
          resolve()
        })
        .catch(err => {
          console.log(err)
          alert(
            'Something went wrong.  Are you blocking Javascript or third ' +
            'party URLs?  Please make sure that access to go.newsreview.com ' +
            'is permitted.  If you need help, let us know —webguy@newsreview.com.'
          )
        })
    })
  },
  getVotingLink: ({commit, state}, payload) => {
    let surveyURL

    // Check if the voting link links to an open survey.
    if (process.env.NODE_ENV === 'development') {
      surveyURL = 'http://localhost:9000/api/open-surveys'
    } else {
      surveyURL = 'https://vote.newsreview.com/api/open-surveys'
    }

    axios.get(surveyURL)
      .then(res => {
        if ('data' in res && res.data.length > 0) {
          let data = res.data

          data.forEach((item) => {
            if (state.project.voting_link.indexOf(item.survey_link) >= 0) {
              const now = new Date()

              if (now > new Date(item.start_date) && now <= new Date(item.end_date)) {
                commit('setVotingLink', item.survey_link)
                commit('setEndDate', item.end_date)
              }
            }
          })
        }
      })
      .catch(err => {
        console.log(err)
      })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/project.js